export const COLLECTED_ITEM = 'collection';
export const GENERIC_EXPORT = 'generic_exports';
export const COHORT_ROLE = 'role';
export const PAYMENT = 'payment';
export const INSTITUTION = 'institute';
export const MODULE = 'module';
export const COURSE = 'course';
export const COMMENT = 'comment';
export const SEARCH = 'search';
export const FEED = 'feed';
export const NOTIFICATION = 'notification';
export const THEME = 'theme';
export const PORTAL = 'portal';
export const PAGE = 'page';
export const COHORT = 'cohort';
export const SUBSCRIPTION_PLAN = 'subscriptionPlan';
export const USER_SUBSCRIPTION_PLAN = 'userSubscriptionPlan';
export const COURSE_MEMBERSHIP = 'course_membership';
export const ENROLMENT = 'enrolment';
export const USER_RESOURCE = 'user';
export const INSTITUTION_RESOURCE = 'institute';
export const EMAIL_RESOURCE = 'email';
export const X_API_RESOURCE = 'xapi';
export const WASABI = 'wasabi';
export const LTI_CONSUMER_RESOURCE = 'ltiConsumer';
export const OPTIMIZELY_RESOURCE = 'optimizely';
export const PAGE_TEMPLATE_RESOURCE = 'pageTemplate';
export const UPLOAD_RESOURCE = 'upload';
export const SUBSCRIPTION_ROLE = 'subscriptionRole';
export const LEARNER_USAGE = 'learnerUsage';
export const WIDGET_INTEGRATION = 'widgetIntegrationProvider';
export const IDENTITY_SESSION = 'identitySession';
export const BLOCK = 'block';
export const STAMP = 'stamp';
export const TERMS_OF_SERVICE = 'terms';
export const TAG_CONTRIBUTION = 'tagContribution';
export const TAG_CONTRIBUTOR = 'tagContributor';
export const BACKGROUND_TASK = 'backgroundTask';
export const FILE = 'file';

export const RESOURCE_NAMES_PLURAL = {
  [COLLECTED_ITEM]: 'Posts',
  [GENERIC_EXPORT]: 'Exports',
  [COHORT_ROLE]: 'Course Roles',
};
